import { resolveCommentsConfig } from "@framework/comments/resolve-comments-config";
import { SB_NATION_NETWORK_ID } from "@framework/config/community/communities";
import { SB_NATION_COMMUNITIES_METADATA } from "@framework/config/community/communities-metadata.sbnation";
import { cycloneConfig } from "@framework/config/cyclone.config";
import { NETWORK_ID } from "@framework/config/network.config";
import type {
  CommentsBrandConfig,
  CommentsConfig,
} from "@voxmedia/duet-context/context/config-context";

/**
 * Resolves runtime CommentsConfig from brand defaults + request context.
 * SB Nation per-community overrides come from communities-metadata.sbnation.ts.
 */
export function resolveCommentsConfigForApp(args: {
  commentsConfig: CommentsBrandConfig;
  communityId: number;
  isMobileApp?: boolean;
}): CommentsConfig {
  const metadata =
    NETWORK_ID === SB_NATION_NETWORK_ID
      ? SB_NATION_COMMUNITIES_METADATA.find(
          (community) => community.communityId === args.communityId,
        )
      : undefined;

  return resolveCommentsConfig({
    isMobileApp: args.isMobileApp,
    commentsProvider: metadata?.commentsProvider,
    commentLocation: metadata?.commentLocation,
    cycloneCommentsDefault: cycloneConfig.commentsEnabled,
    defaultLocation: args.commentsConfig.defaultLocation,
  });
}
